export default __webpack_public_path__ + "static/media/accomm_img_4.8a761874.JPG";